module.exports = __webpack_public_path__ + "static/media/scalpel.3135040e.png";